import MicroModal from 'micromodal';

export default {

	init() {
		console.log('modals init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
		document.addEventListener("DOMContentLoaded", this.bindLoadEvents);
	},

	bindEvents() {
		$('template[data-js=modal]').each(function (index, elem) {
			var modal = elem.content.firstElementChild.cloneNode(true);
			document.body.appendChild(modal);
		});

		$('a[href^="#modal--"]').on('click', function(e){
			e.preventDefault();

			const modalId = $(this).attr('href').split('--')[1];
			Modal.showModalById(modalId);
		});

		if (!$('[data-micromodal-trigger]').length) {
			return;
		}

		$('[data-micromodal-trigger]').on('click', function (e) {
			console.log('modal clicky!');
			e.preventDefault();
		});

		MicroModal.init({
			onShow: Modal.show,
			onClose: Modal.close,
			disableFocus: false,
			disableScroll: true,
			debugMode: true
		});
	},

	bindLoadEvents() {
		const hash = window.location.hash;
		const modalId = hash.substring(1);
		Modal.showModalById(modalId);
	},

	showModalById(modalId) {
		let target = document.getElementById(modalId);

		if(!target || !target.classList.contains('sh-modal')) {
			return;
		}

		setTimeout(function() {
			MicroModal.show(modalId, {
				onShow: Modal.show,
				onClose: Modal.close,
				disableFocus: true,
				disableScroll: true
			});
		}, 200);
	},

	show(modal, trigger, event) {
		$('html').addClass('has-modal-open').addClass('is-modal-open');
	},

	close() {
		$('html').removeClass('has-modal-open').removeClass('is-modal-open');
	}

};
